import { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .ach-section {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 4rem 80px;
    font-family: 'Rajdhani', sans-serif;
  }

  .ach-container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  .ach-header {
    text-align: center;
    margin-bottom: 4rem;
  }

  .ach-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: achFadeUp 0.7s ease 0.1s both;
  }
  .ach-label::before, .ach-label::after { content: ''; width: 50px; height: 1px; }
  .ach-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .ach-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .ach-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    opacity: 0;
    animation: achFadeUp 0.7s ease 0.2s both;
  }

  /* GRID */
  .ach-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    opacity: 0;
    animation: achFadeUp 0.7s ease 0.3s both;
  }

  .ach-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #ff8c00;
    padding: 1.8rem;
    position: relative;
    transition: all 0.3s;
  }

  .ach-card:hover {
    border-color: rgba(255,140,0,0.35);
    box-shadow: 0 0 25px rgba(255,140,0,0.08);
    transform: translateY(-3px);
  }

  .ach-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #ff8c00, transparent);
  }

  .ach-card-top {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .ach-icon-wrap {
    width: 44px;
    height: 44px;
    background: rgba(255,140,0,0.08);
    border: 1px solid rgba(255,140,0,0.25);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    flex-shrink: 0;
  }

  .ach-info {
    flex: 1;
  }

  .ach-card-title {
    font-family: 'Orbitron', monospace;
    font-size: 0.8rem;
    font-weight: 700;
    color: #e8f4ff;
    margin-bottom: 0.3rem;
    line-height: 1.35;
  }

  .ach-card-org {
    font-size: 0.82rem;
    color: #ffaa33;
    font-weight: 600;
  }

  .ach-card-year {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #4a7a9b;
    letter-spacing: 1px;
    margin-top: 0.2rem;
  }

  .ach-card-desc {
    font-size: 0.88rem;
    line-height: 1.7;
    color: rgba(232,244,255,0.5);
    border-top: 1px solid rgba(255,140,0,0.1);
    padding-top: 0.8rem;
    margin-top: 0.5rem;
  }

  .ach-badge {
    display: inline-block;
    background: rgba(255,140,0,0.1);
    border: 1px solid rgba(255,140,0,0.3);
    border-radius: 3px;
    padding: 0.15rem 0.6rem;
    font-family: 'Orbitron', monospace;
    font-size: 0.55rem;
    color: #ffaa33;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-top: 0.8rem;
    display: block;
    width: fit-content;
  }

  @keyframes achFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 900px) {
    .ach-section { padding: 100px 2rem 60px; }
    .ach-grid { grid-template-columns: 1fr; }
  }
`;

const ACHIEVEMENTS = [
  {
    icon: "🥇",
    title: "Best in Capstone Project",
    org: "Malvar Senior High School",
    year: "2023",
    desc: "Awarded Best in Capstone for the Automatic Fire Suppression System using thermally-activated eggshell mechanism.",
    badge: "Best in Project",
  },
  {
    icon: "📚",
    title: "STEM Strand Completion with Honors",
    org: "Malvar SHS",
    year: "2023",
    desc: "Graduated with honors from the Science, Technology, Engineering, and Mathematics strand.",
    badge: "With Honors",
  },
  {
    icon: "🎖️",
    title: "Junior Highschool Inter Lasallian Cup Basketball Mens – Champions",
    org: "De La Salle Lipa",
    year: "2017 – 2021",
    desc: "Received recognition for undefeated in junior high school mens basketball.",
    badge: "Certificate",
  },
];

export default function Achievements() {
  return (
    <section className="ach-section" id="achievements">
      <style>{styles}</style>
      <div className="ach-container">

        <div className="ach-header">
          <p className="ach-label">Honors & Recognition</p>
          <h2 className="ach-title">Academic Achievements</h2>
        </div>

        <div className="ach-grid">
          {ACHIEVEMENTS.map((a, i) => (
            <div className="ach-card" key={i}>
              <div className="ach-card-top">
                <div className="ach-icon-wrap">{a.icon}</div>
                <div className="ach-info">
                  <p className="ach-card-title">{a.title}</p>
                  <p className="ach-card-org">{a.org}</p>
                  <p className="ach-card-year">{a.year}</p>
                </div>
              </div>
              <p className="ach-card-desc">{a.desc}</p>
              <span className="ach-badge">{a.badge}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}